/**
 * AI 分析 - 数据洞察
 */
import React from 'react';
import { Card, Space, Typography } from 'antd';

const { Paragraph } = Typography;

interface DataInsights {
  market_structure: string;
  competition_landscape: string;
  traffic_value: string;
  entry_difficulty: string;
  opportunity_assessment: string;
}

interface AIDataInsightsProps {
  dataInsights: DataInsights;
}

export const AIDataInsights: React.FC<AIDataInsightsProps> = ({ dataInsights }) => {
  return (
    <Card
      title={
        <Space>
          📊 数据洞察
        </Space>
      }
      className="ai-content-card"
    >
      <div className="insight-grid">
        <div className="insight-item">
          <span className="insight-label">🏪 市场结构</span>
          <Paragraph className="insight-value">{dataInsights.market_structure}</Paragraph>
        </div>
        <div className="insight-item">
          <span className="insight-label">⚔️ 竞争格局</span>
          <Paragraph className="insight-value">{dataInsights.competition_landscape}</Paragraph>
        </div>
        <div className="insight-item">
          <span className="insight-label">📈 流量价值</span>
          <Paragraph className="insight-value">{dataInsights.traffic_value}</Paragraph>
        </div>
        <div className="insight-item">
          <span className="insight-label">🚪 进入难度</span>
          <Paragraph className="insight-value">{dataInsights.entry_difficulty}</Paragraph>
        </div>
        <div className="insight-item insight-full">
          <span className="insight-label">💡 机会评估</span>
          <Paragraph className="insight-value">{dataInsights.opportunity_assessment}</Paragraph>
        </div>
      </div>
    </Card>
  );
};

